import { render, staticRenderFns } from "./VqSelect.vue?vue&type=template&id=499e1f84&scoped=true&lang=html&"
import script from "./VqSelect.vue?vue&type=script&lang=js&"
export * from "./VqSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e1f84",
  null
  
)

export default component.exports